// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var Formality = require("../../vendor/re-formality/Formality.bs.js");
var Form__Input = require("../../uikit/reason/atoms/Form/Form__Input.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var Form__Helpers = require("../../reason/common/Form/Form__Helpers.bs.js");
var SystemMessage = require("../../uikit/reason/molecules/SystemMessage/SystemMessage.bs.js");
var SystemMessages = require("../../reason/systemMessages/SystemMessages.bs.js");
var Form__Components = require("../../reason/common/Form/Form__Components.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var MobileInputTextSize = require("../common/Form/MobileInputTextSize.bs.js");
var Formality__ReactUpdate = require("../../vendor/re-formality/Formality__ReactUpdate.bs.js");
var RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
var FormalityCompat__PublicHelpers = require("../../vendor/re-formality/FormalityCompat__PublicHelpers.bs.js");
var PasswordSettings_ChangeCurrentUserPasswordMutation_graphql = require("../../__generated__/PasswordSettings_ChangeCurrentUserPasswordMutation_graphql.bs.js");

var validators_currentPassword = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (function (param) {
      var pw = Form__Helpers.noneIfEmpty(param.currentPassword);
      if (pw !== undefined) {
        return {
                TAG: "Ok",
                _0: pw
              };
      } else {
        return {
                TAG: "Error",
                _0: "is required"
              };
      }
    })
};

var validators_newPassword = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (function (param) {
      var pw = Form__Helpers.noneIfEmpty(param.newPassword);
      if (pw !== undefined) {
        if (pw.length < 8) {
          return {
                  TAG: "Error",
                  _0: "Must be at least 8 characters"
                };
        } else {
          return {
                  TAG: "Ok",
                  _0: pw
                };
        }
      } else {
        return {
                TAG: "Error",
                _0: "is required"
              };
      }
    })
};

var validators_confirmPassword = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (function (param) {
      var confirmPassword = param.confirmPassword;
      var match = Form__Helpers.noneIfEmpty(param.newPassword);
      var match$1 = Form__Helpers.noneIfEmpty(confirmPassword);
      if (match !== undefined) {
        if (match$1 !== undefined && match === match$1) {
          return {
                  TAG: "Ok",
                  _0: confirmPassword
                };
        } else {
          return {
                  TAG: "Error",
                  _0: "Passwords must match"
                };
        }
      } else {
        return {
                TAG: "Error",
                _0: ""
              };
      }
    })
};

var validators = {
  currentPassword: validators_currentPassword,
  newPassword: validators_newPassword,
  confirmPassword: validators_confirmPassword
};

function initialFieldsStatuses(_input) {
  return {
          currentPassword: "Pristine",
          newPassword: "Pristine",
          confirmPassword: "Pristine"
        };
}

function initialState(input) {
  return {
          input: input,
          fieldsStatuses: {
            currentPassword: "Pristine",
            newPassword: "Pristine",
            confirmPassword: "Pristine"
          },
          collectionsStatuses: undefined,
          formStatus: "Editing",
          submissionStatus: "NeverSubmitted"
        };
}

function validateForm(input, validators, fieldsStatuses) {
  var match = fieldsStatuses.currentPassword;
  var tmp;
  tmp = typeof match !== "object" ? validators.currentPassword.validate(input) : match._0;
  var match$1 = fieldsStatuses.newPassword;
  var tmp$1;
  tmp$1 = typeof match$1 !== "object" ? validators.newPassword.validate(input) : match$1._0;
  var match$2 = fieldsStatuses.confirmPassword;
  var tmp$2;
  tmp$2 = typeof match$2 !== "object" ? validators.confirmPassword.validate(input) : match$2._0;
  var currentPasswordResult = tmp;
  var currentPasswordResult$1;
  if (currentPasswordResult.TAG === "Ok") {
    var newPasswordResult = tmp$1;
    if (newPasswordResult.TAG === "Ok") {
      var confirmPasswordResult = tmp$2;
      if (confirmPasswordResult.TAG === "Ok") {
        return {
                TAG: "Valid",
                output: {
                  currentPassword: currentPasswordResult._0,
                  newPassword: newPasswordResult._0,
                  confirmPassword: confirmPasswordResult._0
                },
                fieldsStatuses: {
                  currentPassword: {
                    TAG: "Dirty",
                    _0: currentPasswordResult,
                    _1: "Shown"
                  },
                  newPassword: {
                    TAG: "Dirty",
                    _0: newPasswordResult,
                    _1: "Shown"
                  },
                  confirmPassword: {
                    TAG: "Dirty",
                    _0: confirmPasswordResult,
                    _1: "Shown"
                  }
                },
                collectionsStatuses: undefined
              };
      }
      currentPasswordResult$1 = currentPasswordResult;
    } else {
      currentPasswordResult$1 = currentPasswordResult;
    }
  } else {
    currentPasswordResult$1 = currentPasswordResult;
  }
  return {
          TAG: "Invalid",
          fieldsStatuses: {
            currentPassword: {
              TAG: "Dirty",
              _0: currentPasswordResult$1,
              _1: "Shown"
            },
            newPassword: {
              TAG: "Dirty",
              _0: tmp$1,
              _1: "Shown"
            },
            confirmPassword: {
              TAG: "Dirty",
              _0: tmp$2,
              _1: "Shown"
            }
          },
          collectionsStatuses: undefined
        };
}

function useForm(initialInput, onSubmit) {
  var memoizedInitialState = React.useMemo((function () {
          return initialState(initialInput);
        }), [initialInput]);
  var match = Formality__ReactUpdate.useReducer(memoizedInitialState, (function (state, action) {
          if (typeof action !== "object") {
            switch (action) {
              case "BlurCurrentPasswordField" :
                  var result = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.currentPassword, validators_currentPassword, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  currentPassword: status,
                                  newPassword: init.newPassword,
                                  confirmPassword: init.confirmPassword
                                };
                        }));
                  if (result !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: result,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return "NoUpdate";
                  }
              case "BlurNewPasswordField" :
                  var result$1 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.newPassword, validators_newPassword, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  currentPassword: init.currentPassword,
                                  newPassword: status,
                                  confirmPassword: init.confirmPassword
                                };
                        }));
                  if (result$1 !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$1,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return "NoUpdate";
                  }
              case "BlurConfirmPasswordField" :
                  var result$2 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.confirmPassword, validators_confirmPassword, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  currentPassword: init.currentPassword,
                                  newPassword: init.newPassword,
                                  confirmPassword: status
                                };
                        }));
                  if (result$2 !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$2,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return "NoUpdate";
                  }
              case "Submit" :
                  var match = state.formStatus;
                  if (typeof match === "object" && match.TAG === "Submitting") {
                    return "NoUpdate";
                  }
                  var match$1 = validateForm(state.input, validators, state.fieldsStatuses);
                  if (match$1.TAG !== "Valid") {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: match$1.fieldsStatuses,
                              collectionsStatuses: match$1.collectionsStatuses,
                              formStatus: "Editing",
                              submissionStatus: "AttemptedToSubmit"
                            }
                          };
                  }
                  var output = match$1.output;
                  var error = state.formStatus;
                  var tmp;
                  tmp = typeof error !== "object" || error.TAG !== "SubmissionFailed" ? undefined : error._0;
                  return {
                          TAG: "UpdateWithSideEffects",
                          _0: {
                            input: state.input,
                            fieldsStatuses: match$1.fieldsStatuses,
                            collectionsStatuses: match$1.collectionsStatuses,
                            formStatus: {
                              TAG: "Submitting",
                              _0: tmp
                            },
                            submissionStatus: "AttemptedToSubmit"
                          },
                          _1: (function (param) {
                              var dispatch = param.dispatch;
                              onSubmit(output, {
                                    notifyOnSuccess: (function (input) {
                                        dispatch({
                                              TAG: "SetSubmittedStatus",
                                              _0: input
                                            });
                                      }),
                                    notifyOnFailure: (function (error) {
                                        dispatch({
                                              TAG: "SetSubmissionFailedStatus",
                                              _0: error
                                            });
                                      }),
                                    reset: (function () {
                                        dispatch("Reset");
                                      }),
                                    dismissSubmissionResult: (function () {
                                        dispatch("DismissSubmissionResult");
                                      })
                                  });
                            })
                        };
                  break;
              case "DismissSubmissionError" :
                  var match$2 = state.formStatus;
                  if (typeof match$2 !== "object" || match$2.TAG !== "SubmissionFailed") {
                    return "NoUpdate";
                  } else {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: "Editing",
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case "DismissSubmissionResult" :
                  var match$3 = state.formStatus;
                  if (typeof match$3 !== "object") {
                    if (match$3 === "Editing") {
                      return "NoUpdate";
                    }
                    
                  } else if (match$3.TAG === "Submitting") {
                    return "NoUpdate";
                  }
                  return {
                          TAG: "Update",
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: "Editing",
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "Reset" :
                  return {
                          TAG: "Update",
                          _0: initialState(initialInput)
                        };
              
            }
          } else {
            switch (action.TAG) {
              case "UpdateCurrentPasswordField" :
                  var nextInput = action._0(state.input);
                  return {
                          TAG: "Update",
                          _0: {
                            input: nextInput,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput, state.fieldsStatuses.currentPassword, state.submissionStatus, validators_currentPassword, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            currentPassword: status,
                                            newPassword: init.newPassword,
                                            confirmPassword: init.confirmPassword
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "UpdateNewPasswordField" :
                  var nextInput$1 = action._0(state.input);
                  return {
                          TAG: "Update",
                          _0: {
                            input: nextInput$1,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$1, state.fieldsStatuses.newPassword, state.submissionStatus, validators_newPassword, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            currentPassword: init.currentPassword,
                                            newPassword: status,
                                            confirmPassword: init.confirmPassword
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "UpdateConfirmPasswordField" :
                  var nextInput$2 = action._0(state.input);
                  return {
                          TAG: "Update",
                          _0: {
                            input: nextInput$2,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$2, state.fieldsStatuses.confirmPassword, state.submissionStatus, validators_confirmPassword, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            currentPassword: init.currentPassword,
                                            newPassword: init.newPassword,
                                            confirmPassword: status
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "SetSubmittedStatus" :
                  var input = action._0;
                  if (input !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: input,
                              fieldsStatuses: {
                                currentPassword: "Pristine",
                                newPassword: "Pristine",
                                confirmPassword: "Pristine"
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: "Submitted",
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: {
                                currentPassword: "Pristine",
                                newPassword: "Pristine",
                                confirmPassword: "Pristine"
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: "Submitted",
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case "SetSubmissionFailedStatus" :
                  return {
                          TAG: "Update",
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: {
                              TAG: "SubmissionFailed",
                              _0: action._0
                            },
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "MapSubmissionError" :
                  var map = action._0;
                  var error$1 = state.formStatus;
                  if (typeof error$1 !== "object") {
                    return "NoUpdate";
                  }
                  if (error$1.TAG !== "Submitting") {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: "SubmissionFailed",
                                _0: map(error$1._0)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
                  var error$2 = error$1._0;
                  if (error$2 !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: "Submitting",
                                _0: map(error$2)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return "NoUpdate";
                  }
              
            }
          }
        }));
  var dispatch = match[1];
  var state = match[0];
  var match$1 = state.formStatus;
  var tmp;
  tmp = typeof match$1 !== "object" || match$1.TAG !== "Submitting" ? false : true;
  return {
          updateCurrentPassword: (function (nextInputFn, nextValue) {
              dispatch({
                    TAG: "UpdateCurrentPasswordField",
                    _0: (function (__x) {
                        return nextInputFn(__x, nextValue);
                      })
                  });
            }),
          updateNewPassword: (function (nextInputFn, nextValue) {
              dispatch({
                    TAG: "UpdateNewPasswordField",
                    _0: (function (__x) {
                        return nextInputFn(__x, nextValue);
                      })
                  });
            }),
          updateConfirmPassword: (function (nextInputFn, nextValue) {
              dispatch({
                    TAG: "UpdateConfirmPasswordField",
                    _0: (function (__x) {
                        return nextInputFn(__x, nextValue);
                      })
                  });
            }),
          blurCurrentPassword: (function () {
              dispatch("BlurCurrentPasswordField");
            }),
          blurNewPassword: (function () {
              dispatch("BlurNewPasswordField");
            }),
          blurConfirmPassword: (function () {
              dispatch("BlurConfirmPasswordField");
            }),
          currentPasswordResult: Formality.exposeFieldResult(state.fieldsStatuses.currentPassword),
          newPasswordResult: Formality.exposeFieldResult(state.fieldsStatuses.newPassword),
          confirmPasswordResult: Formality.exposeFieldResult(state.fieldsStatuses.confirmPassword),
          input: state.input,
          status: state.formStatus,
          dirty: (function () {
              var match = state.fieldsStatuses;
              var tmp = match.currentPassword;
              if (typeof tmp === "object") {
                return true;
              }
              var tmp$1 = match.newPassword;
              if (typeof tmp$1 === "object") {
                return true;
              }
              var tmp$2 = match.confirmPassword;
              if (typeof tmp$2 !== "object") {
                return false;
              } else {
                return true;
              }
            }),
          valid: (function () {
              var match = validateForm(state.input, validators, state.fieldsStatuses);
              if (match.TAG === "Valid") {
                return true;
              } else {
                return false;
              }
            }),
          submitting: tmp,
          submit: (function () {
              dispatch("Submit");
            }),
          dismissSubmissionError: (function () {
              dispatch("DismissSubmissionError");
            }),
          dismissSubmissionResult: (function () {
              dispatch("DismissSubmissionResult");
            }),
          mapSubmissionError: (function (map) {
              dispatch({
                    TAG: "MapSubmissionError",
                    _0: map
                  });
            }),
          reset: (function () {
              dispatch("Reset");
            })
        };
}

var FormConfig = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

var genericErrorMessage = "We encountered a problem when trying to update your password. Please contact support if the problem persists.";

var convertVariables = PasswordSettings_ChangeCurrentUserPasswordMutation_graphql.Internal.convertVariables;

var convertResponse = PasswordSettings_ChangeCurrentUserPasswordMutation_graphql.Internal.convertResponse;

var convertWrapRawResponse = PasswordSettings_ChangeCurrentUserPasswordMutation_graphql.Internal.convertWrapRawResponse;

var commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, PasswordSettings_ChangeCurrentUserPasswordMutation_graphql.node, convertResponse, convertWrapRawResponse);

var use = RescriptRelay_Mutation.useMutation(convertVariables, PasswordSettings_ChangeCurrentUserPasswordMutation_graphql.node, convertResponse, convertWrapRawResponse);

var ChangeCurrentUserPasswordMutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use
};

function PasswordSettings(props) {
  var match = use();
  var changePassword = match[0];
  var match$1 = SystemMessages.useSystemMessages();
  var addMessage = match$1.addMessage;
  var form = useForm({
        currentPassword: "",
        newPassword: "",
        confirmPassword: ""
      }, (function (param, param$1) {
          var reset = param$1.reset;
          var notifyOnFailure = param$1.notifyOnFailure;
          var notifyOnSuccess = param$1.notifyOnSuccess;
          changePassword({
                input: {
                  currentPassword: param.currentPassword,
                  newPassword: param.newPassword
                }
              }, undefined, undefined, undefined, (function (response, param) {
                  var match = response.changeCurrentUserPassword;
                  if (match === undefined) {
                    return notifyOnFailure(genericErrorMessage);
                  }
                  switch (match.__typename) {
                    case "CurrentUserPasswordChanged" :
                        addMessage(SystemMessages.Message.make(undefined, "success", "Password updated", 15000, undefined, undefined));
                        notifyOnSuccess(undefined);
                        return reset();
                    case "InvalidCurrentPasswordError" :
                        return notifyOnFailure("The current password you typed is incorrect. Please check it and try again.");
                    case "__unselected" :
                        return notifyOnFailure(genericErrorMessage);
                    
                  }
                }), undefined, undefined);
        }));
  var error = form.status;
  var tmp;
  tmp = typeof error !== "object" || error.TAG !== "SubmissionFailed" ? null : JsxRuntime.jsx(SystemMessage.make, {
          id: "form_submitted",
          time: 5000,
          text: error._0,
          type_: "error",
          dismissible: true,
          secondary: true,
          handleOnDismiss: (function (_id) {
              form.dismissSubmissionResult();
            })
        });
  var match$2 = form.currentPasswordResult;
  var tmp$1;
  tmp$1 = match$2 !== undefined && match$2.TAG !== "Ok" ? ({
        NAME: "Error",
        VAL: match$2._0
      }) : undefined;
  var match$3 = form.newPasswordResult;
  var tmp$2;
  tmp$2 = match$3 !== undefined && match$3.TAG !== "Ok" ? ({
        NAME: "Error",
        VAL: match$3._0
      }) : undefined;
  var match$4 = form.confirmPasswordResult;
  var tmp$3;
  tmp$3 = match$4 !== undefined && match$4.TAG !== "Ok" ? ({
        NAME: "Error",
        VAL: match$4._0
      }) : undefined;
  var tmp$4 = true;
  if (form.valid()) {
    var match$5 = form.status;
    var tmp$5;
    tmp$5 = typeof match$5 !== "object" ? (
        match$5 === "Editing" ? false : true
      ) : (
        match$5.TAG === "Submitting" ? true : false
      );
    tmp$4 = tmp$5;
  }
  return JsxRuntime.jsx("form", {
              children: JsxRuntime.jsxs("div", {
                    children: [
                      tmp,
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx(Form__Input.make, {
                                    labelText: "Current Password",
                                    type: "password",
                                    onChange: (function ($$event) {
                                        form.updateCurrentPassword((function (v, value) {
                                                return {
                                                        currentPassword: value,
                                                        newPassword: v.newPassword,
                                                        confirmPassword: v.confirmPassword
                                                      };
                                              }), $$event.target.value);
                                      }),
                                    onBlur: (function (param) {
                                        form.blurCurrentPassword();
                                      }),
                                    disabled: form.submitting,
                                    status: Core__Option.map(form.currentPasswordResult, (function (x) {
                                            if (x.TAG === "Ok") {
                                              return "ok";
                                            } else {
                                              return "error";
                                            }
                                          })),
                                    value: form.input.currentPassword
                                  }),
                              JsxRuntime.jsx(Form__Components.FieldError.make, {
                                    valid: tmp$1
                                  })
                            ]
                          }),
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx(Form__Input.make, {
                                    labelText: "New Password",
                                    type: "password",
                                    placeholderText: "Must be at least 8 characters",
                                    onChange: (function ($$event) {
                                        form.updateNewPassword((function (v, value) {
                                                return {
                                                        currentPassword: v.currentPassword,
                                                        newPassword: value,
                                                        confirmPassword: v.confirmPassword
                                                      };
                                              }), $$event.target.value);
                                      }),
                                    onBlur: (function (param) {
                                        form.blurNewPassword();
                                      }),
                                    disabled: form.submitting,
                                    status: Core__Option.map(form.newPasswordResult, (function (x) {
                                            if (x.TAG === "Ok") {
                                              return "ok";
                                            } else {
                                              return "error";
                                            }
                                          })),
                                    value: form.input.newPassword
                                  }),
                              JsxRuntime.jsx(Form__Components.FieldError.make, {
                                    valid: tmp$2
                                  })
                            ]
                          }),
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx(Form__Input.make, {
                                    labelText: "Confirm Password",
                                    type: "password",
                                    onChange: (function ($$event) {
                                        form.updateConfirmPassword((function (v, value) {
                                                return {
                                                        currentPassword: v.currentPassword,
                                                        newPassword: v.newPassword,
                                                        confirmPassword: value
                                                      };
                                              }), $$event.target.value);
                                      }),
                                    onBlur: (function (param) {
                                        form.blurConfirmPassword();
                                      }),
                                    disabled: form.submitting,
                                    status: Core__Option.map(form.confirmPasswordResult, (function (x) {
                                            if (x.TAG === "Ok") {
                                              return "ok";
                                            } else {
                                              return "error";
                                            }
                                          })),
                                    value: form.input.confirmPassword
                                  }),
                              JsxRuntime.jsx(Form__Components.FieldError.make, {
                                    valid: tmp$3
                                  })
                            ]
                          }),
                      JsxRuntime.jsx("div", {
                            children: JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
                                  disabled: tmp$4,
                                  children: "Save"
                                }),
                            className: "flex flex-row justify-end pt-4"
                          })
                    ],
                    className: "flex flex-col gap-4"
                  }),
              className: MobileInputTextSize.className,
              onSubmit: (function (extra) {
                  return FormalityCompat__PublicHelpers.Dom.preventDefault(form.submit, extra);
                })
            });
}

var make = PasswordSettings;

exports.FormConfig = FormConfig;
exports.genericErrorMessage = genericErrorMessage;
exports.ChangeCurrentUserPasswordMutation = ChangeCurrentUserPasswordMutation;
exports.make = make;
/* commitMutation Not a pure module */
